module.exports = __webpack_public_path__ + "static/media/J3.d4d3e3f1.png";